var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-editor",class:{ readonly: _vm.readonly }},[_c('ckeditor',{attrs:{"disabled":_vm.readonly,"readonly":_vm.readonly,"config":_vm.editorConfig},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }